/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */
import "mse-tools-masthead-and-footer/lib/css/page-base.css";
import "mse-tools-masthead-and-footer/lib/css/stand-alone-page.css";
import "mse-tool-components/lib/css/index.css";
import "mse-tool-components/src/vendor/modernizr";
import "./src/scss/index.scss";

import { mseGTM } from "mse-tools-masthead-and-footer/lib/mse-gtm";

if (typeof window !== "undefined") {
  mseGTM();
}
